import React, { Suspense } from 'react';
import PropTypes from 'prop-types';

const AsyncReactColorChromePicker = React.lazy(() =>
  import(
    /* webpackChunkName: "ReactColorChromePicker" */ './ReactColorChromePicker'
  ),
);

const ColorPicker = ({ color, disableAlpha = true, onChange = () => {} }) => {
  const onColorChange = ({ hex }) => {
    if (onChange) {
      onChange(hex);
    }
  };

  return (
    <Suspense fallback={null}>
      <AsyncReactColorChromePicker
        disableAlpha={disableAlpha}
        color={color}
        onChange={onColorChange}
      />
    </Suspense>
  );
};

ColorPicker.propTypes = {
  color: PropTypes.string.isRequired,
  disableAlpha: PropTypes.bool,
  onChange: PropTypes.func,
};

export default ColorPicker;
